import ApiService from 'app/services/ApiService';

export const PROCESS_BEGIN = 'PROCESS_BEGIN';
export const PROCESS_SUCCESS = 'PROCESS_SUCCESS';
export const PROCESS_FAILURE = 'PROCESS_FAILURE';
export const CLEAR_PROCESS = 'CLEAR_PROCESS';

export const PROCESS_FILTERS_SUCCESS = 'PROCESS_FILTERS_SUCCESS';
export const PROCESS_FILTERS_BEGIN = 'PROCESS_FILTERS_BEGIN';
export const PROCESS_FILTERS_FAILURE = 'PROCESS_FILTERS_FAILURE';
export const CLEAR_PROCESS_FILTERS = 'CLEAR_PROCESS_FILTERS';

export function fetchProcess(data, id) {
    return async dispatch => {
        dispatch(processBegin());
        await ApiService.getProcess(data, id)
            .then(
                result => {
                    dispatch(processSuccess(result));
                },
                error => {
                    dispatch(processError());
                    // eslint-disable-next-line no-throw-literal
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchProcessFilters(params = {}) {
    return async dispatch => {
        dispatch(processFiltersBegin());
        await ApiService.getProcessFilter(params)
        .then(
            result => {
                dispatch(processFiltersSuccess(result));
            },
            error => {
                dispatch(processFiltersError());
                throw ({ error: error, message: 'An error ocurred' });
            }
            )
        };
    }

export const processBegin = () => ({
    type: PROCESS_BEGIN,
});

export const processSuccess = (data) => ({
    type: PROCESS_SUCCESS,
    payload: { data }
})

export const processError = () => ({
    type: PROCESS_FAILURE,
})

export const clearProcess = () => ({
    type: CLEAR_PROCESS,
});

export const processFiltersBegin = () =>({
    type:PROCESS_FILTERS_BEGIN
})
export const processFiltersSuccess = (data) =>({
    type:PROCESS_FILTERS_SUCCESS,
    payload: { data }
})
export const processFiltersError = () =>({
    type:PROCESS_FILTERS_FAILURE
})
export const clearProcessFilter = () => ({
    type: CLEAR_PROCESS_FILTERS,
});